import Window from 'window-or-global'
import dateFormat from 'date-fns/format'
import diffInDays from 'date-fns/differenceInDays'
import parseISO from 'date-fns/parseISO'

export const dayOfWeekAsString = index => {
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
  if (
    isNaN(Number(index)) ||
    Number(index) >= days.length ||
    Number(index) < 0
  ) {
    Window.console.warn('invalid index provided to dayOfWeekAsString')
    return undefined
  }
  return days[Number(index)]
}

export const toEndDate = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  try {
    return dateFormat(date, 'yyyy-MM-dd') + 'T23:59:59.999'
  } catch (e) {
    Window.console.warn('invalid date provided to toEndDate')
    return undefined
  }
}

export const toStartDate = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  try {
    return dateFormat(date, 'yyyy-MM-dd') + 'T00:00:00'
  } catch (e) {
    Window.console.warn('invalid date provided to toStartDate')
    return undefined
  }
}

export const differenceInDays = (date1, date2) => {
  if (typeof date1 === 'string') date1 = parseISO(date1)
  if (typeof date2 === 'string') date2 = parseISO(date2)
  if (isNaN(date1) || isNaN(date2)) {
    Window.console.warn('invalid date provided to differenceInDays')
    return undefined
  }
  return Math.abs(diffInDays(date1, date2))
}

/* All browser date/time parsing wants to
 * convert the date to whatever timezone the browser is in
 * this sucks because that's not how we want to display it
 * to the end user.  We're stripping out the timezone
 * information so that when it parses it it will display
 * correctly.  This is specifically an issue with dates
 * that contain times
 */
export const format = (date, format) => {
  let newDate = date
  let timeOffset = false

  try {
    [newDate, timeOffset] = date.split('T')
  } catch (e) {}

  if (timeOffset) {
    let [time] = timeOffset.split(/[-+]/gi)

    newDate = `${newDate}T${time}`
  }
  if (typeof newDate === 'string') newDate = parseISO(newDate)
  try {
    return dateFormat(newDate, format)
  } catch (e) {
    Window.console.warn('invalid date provided to format:', date)
    return undefined
  }
}
